// src/components/setupstyles/Sidebar.js

import React, { useState } from 'react';
import { Box, Typography, List, ListItem, ListItemText, ListItemIcon, Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import Logo from '../../assets/mindguard_logo_final.png';
import PaymentModal from '../PaymentModal'; // Import the PaymentModal

const Sidebar = ({ onSelect }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [openPayment, setOpenPayment] = useState(false); // State to control modal visibility

  const botInviteURL = `https://discord.com/oauth2/authorize?client_id=1295817369163399259&permissions=947308850288&redirect_uri=${encodeURIComponent(
    process.env.REACT_APP_DISCORD_REDIRECT_URI_ADMIN
  )}&scope=bot%20applications.commands`;


  const handleSelect = (selection) => {
    if (onSelect) {
      onSelect(selection);
    }
  };

  const handleOpenPayment = () => {
    setOpenPayment(true);
  };

  const handleClosePayment = () => {
    setOpenPayment(false);
  };

  return (
    <Box
      sx={{
        width: '240px', // Fixed width for Sidebar
        minHeight: '100vh', // Full viewport height
        backgroundColor: '#040813', // Dark background from the palette
        color: '#C2CCDF', // Light text color for contrast
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: 4,
        borderRadius: '0 10px 10px 0',
        boxShadow: '2px 0 5px rgba(0, 0, 0, 0.5)',
        position: 'relative', // Ensure it stays in place
        zIndex: 1000, // Ensure it stays above other elements
      }}
    >
      {/* MINDguard Title at the Top */}
      <Typography variant="h4" sx={{ marginBottom: 4, color: '#A1D1F0', fontWeight: 'bold' }}>
        MINDguard
      </Typography>

      {/* Sidebar Links */}
      <List sx={{ width: '100%', flexGrow: 1 }}>
        {[
          { text: 'Homepage', path: '/' },
          { text: 'Server Config', path: '/setup' },
          { text: 'Current Configs', path: '/current-configs' },
        ].map((item) => (
          <ListItem
            button
            key={item.text}
            onClick={() => {
              handleSelect(item.text.toLowerCase().replace(' ', ''));
              navigate(item.path);
            }}
            sx={{
              '&:hover': {
                backgroundColor: '#081529',
                cursor: 'pointer',
              },
              backgroundColor: location.pathname === item.path
                ? '#081529'
                : 'inherit',
              color: location.pathname === item.path ? '#A1D1F0' : '#C2CCDF', // White text when active
              marginBottom: 1,
              borderRadius: '8px',
              paddingY: 1.5,
              paddingX: 2,
              fontFamily: 'Poppins, sans-serif',
              transition: 'background-color 0.3s, color 0.3s',
            }}
          >
            <ListItemIcon
              sx={{
                color: location.pathname === item.path ? '#A1D1F0' : '#C2CCDF', // Soft Cyan for active icons
                minWidth: '40px',
              }}
            >
              {/* Optionally add an icon here */}
            </ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>

      {/* Add Bot to Server Button */}
      <Button
        variant="contained"
        color="primary"
        href={botInviteURL}
        target="_blank"
        sx={{
          marginBottom: 2,
          textTransform: 'none',
          backgroundColor: '#728C63',
          '&:hover': {
            backgroundColor: '#8BA675',
          },
          color: '#FFFFFF',
          borderRadius: '8px',
          padding: '10px 20px',
          fontFamily: 'Poppins, sans-serif',
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
        }}
      >
        Add MINDguard to Server
      </Button>

      {/* Logo at the Bottom */}
      <Box
        component="a"
        href="https://mindao.xyz/"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          marginBottom: 4,
        }}
      >
        <Box
          component="img"
          src={Logo}
          alt="MINDguard Logo"
          sx={{ width: '150px', height: 'auto' }}
        />
      </Box>

      {/* Payment Modal */}
      <PaymentModal open={openPayment} handleClose={handleClosePayment} />
    </Box>
  );
};

export default Sidebar;

